export const ZillowIcon = ({ className = "h-6 w-6" }: { className?: string }) => {
  return (
    <svg 
      clipRule="evenodd" 
      fillRule="evenodd" 
      height="24" 
      strokeLinejoin="round" 
      strokeMiterlimit="2" 
      viewBox="0 0 23.283 25.577" 
      width="24" 
      xmlns="http://www.w3.org/2000/svg" 
      className={className}
    >
      <g fill="#006aff" fillRule="nonzero">
        <path d="m15.743 6.897c.117-.026.169.013.24.091.403.448 1.691 2.021 2.041 2.45.065.078.02.163-.032.208-2.6 2.028-5.493 4.901-7.105 6.955-.032.046-.006.046.02.039 2.808-1.209 9.405-3.14 12.376-3.679v-3.763l-11.628-9.198-11.648 9.191v4.114c3.607-2.144 11.953-5.466 15.736-6.408z" />
        <path d="m6.279 22.705c-.097.052-.176.039-.254-.039l-2.171-2.587c-.058-.072-.065-.111.013-.221 1.678-2.457 5.103-6.286 7.287-7.904.039-.026.026-.059-.02-.039-2.275.741-8.742 3.523-11.134 4.875v8.787h23.277v-8.462c-3.172.539-12.675 3.367-16.998 5.59z" />
      </g>
    </svg>
  );
};
